import React from 'react';
import classNames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/cardBodyStyle.js';
import { gradients } from 'assets/jss/material-dashboard-pro-react';

// @ts-ignore
const useStyles = makeStyles(styles);

interface ICardBodyProps {
	className?: string;
	background?: boolean;
	plain?: boolean;
	formHorizontal?: boolean;
	pricing?: boolean;
	signup?: boolean;
	color?: boolean;
	profile?: boolean;
	calendar?: boolean;
	gradient?: types.theme.gradients;
	children?: React.ReactElement | React.ReactElement[] | string | string[];
}
const CardBody = ({
	className,
	children,
	background,
	plain,
	formHorizontal,
	pricing,
	signup,
	color,
	profile,
	calendar,
	gradient,
	...rest
}: ICardBodyProps) => {
	const classes = useStyles();
	const cardBodyClasses = classNames({
		[classes.cardBody]: true,
		[classes.cardBodyBackground]: background,
		[classes.cardBodyPlain]: plain,
		[classes.cardBodyFormHorizontal]: formHorizontal,
		[classes.cardPricing]: pricing,
		[classes.cardSignup]: signup,
		[classes.cardBodyColor]: color,
		[classes.cardBodyProfile]: profile,
		[classes.cardBodyCalendar]: calendar,
		[classes.gradient]: gradient,
		[!!className ? className : '']: className !== undefined,
	});

	const backgroundGradient = gradient && { ...gradients[gradient] };
	return (
		<div style={backgroundGradient} {...rest} className={cardBodyClasses}>
			{children}
		</div>
	);
};

export default CardBody;
